import React, { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import {
 Heading,
 Box,
 Button,
 Flex,
 TableContainer,
 Table,
 Thead,
 Tbody,
 Tr,
 Td,
 Th,
 useToast,
} from '@chakra-ui/react';
import { AttentionModal, SuccessModal, SurveySelectorModal } from '../Modals';
import baseService from '../../services/base';
import TableMenu from '../Menu/TableMenu';

export default function QuestionnaireTable({
 groupSurveys,
 companyRegister,
 idCompanyGroup,
 mutate,
}) {
 const toast = useToast();
 const navigate = useNavigate();
 const [currentSurvey, setCurrentSurvey] = useState();
 const [editForm, setEditForm] = useState(false);

 const [isAddQuestionnaireModalOpen, setIsAddQuestionnaireModalOpen] = useState(false);
 const [confirmationModalIsOpen, setConfirmationModalIsOpen] = useState(false);
 const [successModalOpen, setSuccessModalOpen] = useState(false);
 const [confirmationModalIsLoading, setConfirmationModalIsLoading] = useState(false);

 async function removeSurvey() {
  setConfirmationModalIsLoading(true);
  try {
   const response = await baseService.delete(
    `/company/linkSurveyCompany/${companyRegister}/${currentSurvey}`
   );
   console.log('response delete', response);
   if (response) {
    setConfirmationModalIsOpen(false);
    setSuccessModalOpen(true);
   }
  } catch (err) {
   toast({
    title: 'Não foi possível remover o questionário',
    status: 'error',
    duration: 5000,
    isClosable: true,
   });
  } finally {
   setConfirmationModalIsLoading(false);
  }
 }

 const handleCloseSuccess = () => {
  setSuccessModalOpen(false);
  mutate(`/company/linkSurveyCompany/${companyRegister}`);
 };

 const editSurvey = (form) => {
  setEditForm(form);
  setIsAddQuestionnaireModalOpen(true);
 };

 const closeFormModal = () => {
  setIsAddQuestionnaireModalOpen(false);
  setEditForm(false);
 };

 const handleRemoveSurvey = (surveyId) => {
  setCurrentSurvey(surveyId);
  setConfirmationModalIsOpen(true);
 };

 const handleCloseConfirmation = () => {
  setConfirmationModalIsOpen(false);
  setCurrentSurvey(null);
 };

 function checkDeadline(date) {
  let isClosed = false;
  const endApplicationDate = new Date(date);
  const currentDate = new Date();

  if (endApplicationDate < currentDate) {
   isClosed = true;
  }
  return isClosed;
 }

 const formatDate = (dateString) => {
  if (!dateString) return '--';
  const date = parseISO(dateString);
  return format(date, 'dd/MM/yyyy');
};
 return (
  <Box>
   <Flex align='center' justify={'space-between'} mb='32px'>
    <Heading as='h2' fontSize='20px' lineHeight='24.8px'>
     Questionários para respondentes
    </Heading>

    <Button
     onClick={() => setIsAddQuestionnaireModalOpen(true)}
     variant='primary'
     w='237px'
     height='56px'
     isDisabled={!companyRegister}
    >
     Adicionar questionário
    </Button>
   </Flex>

   <TableContainer>
    <Table>
     <Thead height='51px' bg='#EAEAEA' p={0}>
      <Tr p={0} fontWeight={500}>
       <Th p='4' fontSize='14px' color='#16262E' width='25%'>
        Nome do Questionário
       </Th>
       <Th fontSize='sm' p='4' color='#16262E' w='15%'>
        Exercício
       </Th>
       <Th fontSize='sm' p='4' color='#16262E' w='20%'>
        Prazo inicial
       </Th>
       <Th fontSize='sm' p='4' color='#16262E' width='20%'>
        Prazo final
       </Th>
       <Th fontSize='sm' p='4' color='#16262E' w='25%'>
        Ações
       </Th>
      </Tr>
     </Thead>
     <Tbody>
      {groupSurveys && groupSurveys?.length > 0
       ? groupSurveys?.map((form, index) => (
          <Tr
           key={form?.link_survey_company_id_link_survey_company}
           color='#1e1f21'
           fontWeight={500}
           padding='0'
          >
           <Td whiteSpace='nowrap' fontSize='13px' p='4'>
            {form.s_description}
           </Td>

           <Td whiteSpace='nowrap' fontSize='13px' p='4'>
            {form.s_exercise ?? '--'}
           </Td>

           <Td whiteSpace='nowrap' fontSize='13px' p='4'>
            {formatDate(form?.link_survey_company_reference_month_year)}
           </Td>
           <Td whiteSpace='nowrap' fontSize='13px' p='4'>
            {formatDate(form?.link_survey_company_end_application_date)}
           </Td>
           <Td p='4' display='flex' alignItems='center' gap='13px'>
            <Button
             p='0 11px'
             h='29px'
             fontSize='sm'
             fontWeight='600'
             color='white'
             bg='#0173BC'
             _hover={{
              bg: '#0173BC',
             }}
             onClick={() => editSurvey(form)}
            >
             Editar
            </Button>

            <Button
             p='0 11px'
             h='29px'
             fontSize='sm'
             fontWeight='600'
             color='white'
             bg='#FF6700'
             _hover={{
              bg: '#FF6700',
             }}
             onClick={() => handleRemoveSurvey(form.s_id_survey)}
            >
             Remover
            </Button>

            <Button
             h='29px'
             fontSize='sm'
             fontWeight='600'
             color='#0173BC'
             bg='white'
             border='1px solid #0173BC'
             onClick={() =>
              navigate(
               `/registration/company/respondents/${form.s_id_survey}?cr=${companyRegister}&cg=${idCompanyGroup}`
              )
             }
            >
             Respondentes
            </Button>
            <Button
             h='29px'
             fontSize='sm'
             fontWeight='600'
             color='#0173BC'
             bg='white'
             border='1px solid #0173BC'
             onClick={() =>
              navigate(
               `/registration/company/reviewers/${form.s_id_survey}?cr=${companyRegister}&cg=${idCompanyGroup}`
              )
             }
            >
             Revisores
            </Button>
           </Td>
          </Tr>
         ))
       : null}
     </Tbody>
    </Table>
   </TableContainer>
   {isAddQuestionnaireModalOpen && (
    <SurveySelectorModal
     onClose={closeFormModal}
     isOpen={isAddQuestionnaireModalOpen}
     id_company={companyRegister}
     editForm={editForm}
     groupSurveys={groupSurveys}
    />
   )}

   <AttentionModal
    isOpen={confirmationModalIsOpen}
    onClose={handleCloseConfirmation}
    submit={removeSurvey}
    title='Deseja remover o questionário vinculado?'
    isLoading={confirmationModalIsLoading}
   />
   <SuccessModal
    isOpen={successModalOpen}
    onClose={handleCloseSuccess}
    title={'Questionário removido com sucesso'}
   />
  </Box>
 );
}
